import { Vue, Component, Prop, Watch, Emit } from 'vue-property-decorator';
import { Getter } from 'vuex-class';

import EditableTable from '@/../bower_components/teknisavuecomponents/components/grids/EditableTable.vue';
import OcorDialog from '@/components/demonstrativo/OcorDialog/OcorDialog.vue';

import HttpRequest from '@/../bower_components/teknisavuecomponents/assets/utils/HttpRequest';
import Time from '@/../bower_components/teknisavuecomponents/assets/utils/Time';
import Util from '@/../bower_components/teknisavuecomponents/assets/utils/Util';
import SnackbarUtils from '@/../bower_components/teknisavuecomponents/assets/utils/SnackbarUtils';
import MarcacaoUtils from '@/assets/ts/utils/MarcacaoUtils';
import FileUtils from '@/../bower_components/teknisavuecomponents/assets/utils/FileUtils';
import { OcorrenciaController } from '@/assets/ts/controller/OcorrenciaController';
import MarcacoesIndividuaisPopup from '@/components/demonstrativo/MarcacoesIndividuaisPopup/MarcacoesIndividuaisPopup.vue';
import MarcacaoController from '@/assets/ts/controller/MarcacaoController';
import ExpectedError from '@/../bower_components/teknisavuecomponents/assets/utils/ExpectedError';
import IntervaloController from '@/assets/ts/controller/IntervaloController';
import EditableTableColumn from 'bower_components/teknisavuecomponents/assets/interfaces/EditableTableColumn';
import EscalaController from '@/assets/ts/controller/EscalaController';
import DateUtil from '@/../bower_components/teknisavuecomponents/assets/utils/DateUtil';
import { AxiosResponse } from 'axios';
import { ControleAcessoWrapper, ModuloPermissao } from '@/assets/ts/controller/ControleAcessoController';

@Component({
  name: 'MarcacoesPopup',
  components: {
    EditableTable,
    OcorDialog,
    MarcacoesIndividuaisPopup,
  }
})
class MarcacoesPopup extends Vue {
  // #region [ PROPS ]
  @Prop({ required: true })
  private readonly dia : string | string[];

  @Prop({ default: null })
  private readonly popupTitle : string;

  @Prop({ default: 0 })
  private readonly triggerReload : number;

  @Prop({ required: true})
  private readonly value : boolean;

  @Prop({ required: true })
  private readonly vinculo : Vinculo;
  /* #endregion */

  // #region [ STORE ]
  @Getter('periodoDemonstrativoAtual')
  private periodoDemonstrativoAtual: any;

  @Getter('user')
  private user: any;

  // @Getter('periodoIsOpen')
  // private periodoIsOpen: boolean;
  // #endregion

  // #region [ EVENTS ]
  @Emit('input')
  private emitInput(value: boolean, changed: boolean) {
    return [value, changed];
  }
  // #endregion

  // #region [ DATA ]
  private internalDate: string | string[] = null;

  private lastRequest: number = null;
  private lastReqHorario: number = null;

  private popupModes = {
    singleDateMode: 'singleDateMode',
    multipleDateMode: 'multipleDateMode',
  };

  private periodoModes = {
    periodoClosed: 'periodoClosed',
    periodoOpen: 'periodoOpen',
  };

  private allToolbarActions = {
    reload: {
      name: 'reload',
      label: 'Atualizar',
      icon: 'mdi-refresh',
      onClick: this.reloadTable,
    },
    add: {
      name: 'addMarc',
      label: 'Adicionar',
      icon: 'mdi-plus-circle',
      onClick: ControleAcessoWrapper.criar(this.onAdd),
    },
    intervalo: {
      name: 'intervalo',
      label: 'Intervalo',
      icon: 'mdi-clock',
      menu: true,
      items: [
        {
          name: 'intervaloAntes',
          label: 'Antes',
          onClick: ControleAcessoWrapper.criar(this.addIntervaloAntes),
        },
        {
          name: 'intervaloDepois',
          label: 'Depois',
          onClick: ControleAcessoWrapper.criar(this.addIntervaloDepois),
        },
      ],
    },
    individual: {
      name: 'marcacoesIndividuais',
      label: 'Ver Marcações',
      icon: 'mdi-calendar-text',
      onClick: this.openMarcacoesIndividuaisPopup,
    },
  };

  private allActions = {
    setAlmoco: {
      name: 'setAlmoco',
      label: 'Definir Como Almoço',
      icon: 'mdi-silverware-fork-knife',
      onClick: ControleAcessoWrapper.criar(this.setAlmoco),
      mode: 'view',
      condition: this.canSetAlmoco,
    },
    showOcor: {
      name: 'showOcor',
      label: 'Adicionar Ocorrência',
      icon: 'mdi-android-messages',
      onClick: ControleAcessoWrapper.criar(this.openOcorDialog, ModuloPermissao.MODULO_OCORRENCIAS),
      mode: 'view',
      condition: this.canSetOcorrencia,
    },
    edit: {
      name: 'edit',
      condition: this.isTrabalhoAndAnyFieldEditable
    },
    delete: {
      name: 'delete',
      label: 'Excluir',
      icon: 'mdi-delete',
      onClick: ControleAcessoWrapper.deletar(this.onDelete),
      mode: 'view',
      condition: this.isTrabalhoAndAllFieldsEditable,
    },
    deleteIntervalo: {
      name: 'deleteIntervalo',
      label: 'Excluir',
      icon: 'mdi-delete',
      onClick: ControleAcessoWrapper.deletar(this.deleteIntervalo),
      mode: 'view',
      condition: this.isIntervalo,
    },
    saveMarcacao: {
      name: 'save',
      label: 'Salvar',
      icon: 'mdi-content-save',
      onClick: ControleAcessoWrapper.criar(this.onSave),
      mode: 'edit',
    },
    download: {
      name: 'download',
      label: 'Baixar Documento da Ocorrência',
      icon: 'mdi-download',
      onClick: this.downloadFile,
      mode: 'view',
      condition: this.hasFile,
    },
    cancel: 'cancel',
  };

  private modes = {
    singleDateMode: {
      gridSingleLine: true,
      periodoOpen: {
        toolbarActions: [
          this.allToolbarActions.reload,
          this.allToolbarActions.add,
          this.allToolbarActions.intervalo,
          this.allToolbarActions.individual,
        ],
        almocoOptions: {
          iconLabel: 'Remover Almoço',
        },
        actions: [
          this.allActions.setAlmoco,
          this.allActions.showOcor,
          this.allActions.edit,
          this.allActions.delete,
          this.allActions.saveMarcacao,
          this.allActions.cancel,
          this.allActions.download,
        ],
      },
      periodoClosed: {
        almocoOptions: {
          iconLabel: 'Almoço',
        },
        toolbarActions: [
          this.allToolbarActions.reload,
          this.allToolbarActions.individual,
        ],
        actions: [
          this.allActions.download,
        ],
      },
    },
    multipleDateMode: {
      gridSingleLine: true,
      almocoIsEditable: true,
      almocoOptions: {
        iconLabel: 'Remover Almoço',
      },
      toolbarActions: [
        this.allToolbarActions.reload,
        this.allToolbarActions.add,
        this.allToolbarActions.individual,
      ],
      actions: [
        this.allActions.setAlmoco,
        this.allActions.saveMarcacao,
        this.allActions.cancel,
        this.allActions.edit,
        this.allActions.delete,
        this.allActions.showOcor,
        this.allActions.download,
      ],
    },
  };

  private popupMultipleDatesTitle = 'Dias Marcados';

  private rows = [];

  private loadingItems = {
    reload: false,
    horarioBase: false,
    outro: false,
  };

  // private loading = false;

  private showOcorDialog = false;
  private nrMarcacao = '';
  private hrMarcacao = '';
  private nmEscala = '';

  private triggerAddRow = 0;

  private internalValue = false;
  private changed = false;

  private defaultRow = {
    IDMARCACAO: 'Trabalho',
    DTHRINICIO: '',
    DTHRFIM: '',
    TEMPO: '',
    DIA_INICIO: 'FC',
    DIA_FIM: 'FC',
  };

  private marcacoesIndividuaisPopup = {
    show: false,
    data: {
      dias: null,
      nrVinculo: '',
    },
    control: null as any,
    changed: false,
  };

  private edited = false;

  private idCurrentRow = '';
  private isInicioReadonlyOnEdit = false;
  private isFimReadonlyOnEdit = false;
  private ocorDialogLoading = false;

  private idsDias = [
    {
      name: 'FS',
      label: 'DS',
      selectLabel: 'Seguinte',
    },
    {
      name: 'FC',
      label: 'DC',
      selectLabel: 'Corrente',
    },
    {
      name: 'FA',
      label: 'DA',
      selectLabel: 'Anterior',
    },
  ];

  private gridKey = 0;
  // #endregion

  // #region [ COMPUTED ]
  private get cardTitle() {
    // Tratativa Cadastro Automatico
    const currentDay = this.currentPopupMode === this.popupModes.multipleDateMode ? this.popupMultipleDatesTitle : this.internalDate;
    const shiftName = (this.currentPopupMode === this.popupModes.multipleDateMode) || !this.nmEscala ? '' : ' (' +  this.nmEscala + ')';

    const title = `Marcações - ${currentDay}${shiftName}`;

    return title;
  }

  private get toolbarActions(): any[] {
    const actions = this.currentMode.toolbarActions;

    return actions;
  }

  private get actions(): any[] {
    // Modo que deveria funcionar, não ativo por questão de conflito
    const actions = this.currentMode.actions;

    return actions;
  }

  private get periodoIsOpen(): boolean  {
    // const isOpen =
    //   this.periodoDemonstrativoAtual.IDPERIODOAPURACAO === 'ABERTO';

    const isOpen = this.$store.state.periodoIsOpen;

    return isOpen;
  }

  private get canUserEditCurrentPeriodo() {
    const canUserEditCurrentPeriodo = this.$store.state.canUserEditCurrentPeriodo;

    return canUserEditCurrentPeriodo;
  }

  private get tableReadonly(): boolean {
    const readonly = !this.periodoIsOpen;

    return readonly;
  }

  private get hasAlmoco(): boolean {
    const almoco = this.rows.reduce((accumulator: boolean, row: any) => {
        const rowIsAlmoco = row.ISALMOCO === 'true';
        return accumulator || rowIsAlmoco;
    }, false);

    return almoco;
  }

  private get currentMode() {
    const currentPopupMode = this.modes[this.currentPopupMode];
    if (!currentPopupMode[this.currentPeriodoMode]) {
      return currentPopupMode;
    }
    // check for global properities inside the mode (not inside periodo)
    const globalProperties = {};
    for (const property in currentPopupMode) {
      if (property !== this.periodoModes.periodoClosed && property !== this.periodoModes.periodoOpen) {
        globalProperties[property] = currentPopupMode[property];
      }
    }

    return  {
      ...currentPopupMode[this.currentPeriodoMode],
      ...globalProperties,
    }

  }

  private get currentPopupMode() {
    return this.isMultipleDate ? this.popupModes.multipleDateMode : this.popupModes.singleDateMode;
  }

  private get isMultipleDate(): boolean {
    const isMultiple = Array.isArray(this.internalDate);
    return isMultiple;
  }

  private get currentPeriodoMode() {
    const periodoIsOpenToEditions = this.canUserEditCurrentPeriodo;
    const periodoMode = periodoIsOpenToEditions ? this.periodoModes.periodoOpen : this.periodoModes.periodoClosed;

    return periodoMode;
  }

  private get isPopupSingleMode() {
    return this.currentPopupMode === this.popupModes.singleDateMode;
  }

  private get isPopupMultipleMode() {
    return this.currentPopupMode === this.popupModes.multipleDateMode;
  }

  private get isGridSingleLine() {
    return this.currentMode.gridSingleLine;
  }

  private get datesArray(): string[] {
    const dates = Array.isArray(this.internalDate) ?
      this.internalDate :
      [this.internalDate];

    return dates;
  }

  private get currentRow(): any {
    const current = this.rows.find((row: any) => {
      const isEditing = row.__mode === 'edit';
      return isEditing;
    });

    return current || null;
  }

  private get saveOcorrenciaAction(): ((row: any) => void) {
    if (this.idCurrentRow === 'before' || this.idCurrentRow === 'after') {
      return this.insertIntervalo;
    }

    return undefined;
  }

  private get columns(): EditableTableColumn[] {
    const cols = [
      {
        text: 'Tipo',
        value: 'IDMARCACAO',
        align: 'left',
        readonly: true,
        style: this.tipoStyle,
      },
      {
        text: 'Início',
        value: 'DTHRINICIO',
        type: 'text',
        align: 'center',
        mask: '##:##',
        fieldSize: '60px',
        readonly: this.isMarcacaoInicioReadonly,
        style: this.inicioStyle,
      },
      {
        text: 'Fim',
        value: 'DTHRFIM',
        type: 'text',
        align: 'center',
        mask: '##:##',
        fieldSize: '60px',
        readonly: this.isMarcacaoFimReadonly,
        style: this.fimStyle,
      },
      {
        text: 'Dia Entrada',
        value: 'DIA_INICIO',
        type: 'select',
        fieldSize: '60px',
        readonly: this.isMarcacaoInicioReadonly,
        descriptionField: 'label',
        selectDescription: 'selectLabel',
        valueField: 'name',
        items: this.idsDias,
      },
      {
        text: 'Dia Saída',
        value: 'DIA_FIM',
        type: 'select',
        fieldSize: '60px',
        readonly: this.isMarcacaoFimReadonly,
        descriptionField: 'label',
        selectDescription: 'selectLabel',
        valueField: 'name',
        items: this.idsDias,
      },
      {
        text: 'Tempo',
        value: 'TEMPO',
        type: 'time',
        align: 'left',
        readonly: true,
        style: this.tempoStyle,
      },
      {
        text: '',
        tooltip: this.getIconTooltip,
        type: 'icon',
        icon: this.getIcon,
        color: this.getIconColor,
        align: 'center',
        readonly: true,
        condition: this.iconIsClickable
      },
    ];

    return cols;
  }

  private get nrVinculo(): string {
    const nrVinculo = this.vinculo ?
      this.vinculo.NRVINCULOM :
      '';

    return nrVinculo;
  }

  private get hasMarcacao(): boolean {
    const hasMarcacao = this.rows.reduce((accumulator: boolean, row: any) => {
      const isTrabalho = this.isTrabalho(row);
      const isNew = row.__is_new === true;

      return (isTrabalho && !isNew) || accumulator;
    }, false);

    return hasMarcacao;
  }

  private get nextDay(): string {
    const isLastDay =
      this.internalDate ===
      this.periodoDemonstrativoAtual.DTFINALAPURACAO;

    if (isLastDay || this.internalDate === null || Array.isArray(this.internalDate)) {
      return null;
    }

    const next = DateUtil.addDaysDate(this.internalDate, 1);

    return next;
  }

  private get previousDay(): string {
    const isFirstDay =
      this.internalDate ===
      this.periodoDemonstrativoAtual.DTINICIALAPURACAO;

    if (isFirstDay || this.internalDate === null || Array.isArray(this.internalDate)) {
      return null;
    }

    const previous = DateUtil.addDaysDate(this.internalDate, -1);

    return previous;
  }

  private get loading(): boolean {
    const loading = Util.anyTrue(Object.values(this.loadingItems));

    return loading;
  }

  private get isMarcacaoInicioReadonly(): boolean {
    return this.idCurrentRow === 'after' || (this.isInicioReadonlyOnEdit && this.user.idbloqueioedicaomarc);
  }

  private get isMarcacaoFimReadonly(): boolean {
    return this.idCurrentRow === 'before' || (this.isFimReadonlyOnEdit && this.user.idbloqueioedicaomarc);
  }
  // #endregion

  // #region [ WATCHERS ]
  @Watch('value', { immediate: true })
  private async valueOnChange() {
    this.internalValue = this.value;

    if (this.value) { // Popup foi aberto
      this.changed = false;

      // tempo para o internalDate atualizar
      await Util.setTimeout(10);

      // Busca escala do vínculo
      this.loadHorarioBase();

      // Tratativa Cadastro Automatico
      this.rows = [];

      this.reloadTable();
    }
  }

  @Watch('marcacoesIndividuaisPopup.show')
  private marcacoesIndividuaisPopupOnChangeVisibility(show: boolean) {
    if (!show && this.marcacoesIndividuaisPopup.changed) {
      this.reloadTable();
      this.changed = true;
    }
  }

  @Watch('dia', { immediate: true })
  private diaOnChange() {
    this.internalDate = this.dia;
  }
  // #endregion

  // #region [ METHODS ]
  private closeButtonOnClick() {
    this.closeDialog();
  }

  private closeDialog() {
    this.internalValue = false;
    this.emitInput(this.internalValue, this.changed);
  }

  private tipoStyle(row : any) {
    const colorRelations = {
      Trabalho: 'green',
      Ausência: 'red',
      TOTAL: 'blue',
    };

    const color =
      colorRelations[row.IDMARCACAO] ||
      'red';

    const weight = row.IDMARCACAO === 'TOTAL' ?
      'bold' :
      'normal';

    const style = {
      color,
      'font-weight': weight,
    };

    return style;
  }

  private tempoStyle(row : any) {
    const weight = row.IDMARCACAO === 'TOTAL' ?
      'bold' :
      'normal';

    const style = {
      'font-weight': weight,
    };

    return style;
  }

  private onSave(row : any, tableRows : any[]) {
    row.DTHRINICIO = MarcacaoUtils.formatMarcacaoTime(row.DTHRINICIO);
    row.DTHRFIM = MarcacaoUtils.formatMarcacaoTime(row.DTHRFIM);

    if (Util.isEmptyOrBlank(this.currentRow.DTHRINICIO)) {
      SnackbarUtils.showMessage('Pelo menos o início do intervalo deve ser preenchido.', SnackbarUtils.TYPE_ALERT);
      return;
    }

    this.updateTempoColumn(row);

    if (!this.timesAreValid(row)) {
      const message = 'O horário inicial não pode ser superior ao final.';
      SnackbarUtils.showMessage(message, 'alert', 5000);

      return;
    }

    if (row.IDMARCACAO === 'Trabalho') {
      this.saveMarcacao(row);
    } else {
      this.onSaveIntervalo();
    }
  }

  private saveMarcacao(row: any) {
    if (row.__is_new) {
      // Verifica a permissão para criação
      const saveNewMarcacaoWithPermission = ControleAcessoWrapper.criar(this.saveNewMarcacao);
      saveNewMarcacaoWithPermission(row); // Chama a função após a validação
    } else {
      // Verifica a permissão para atualização
      const editMarcacaoWithPermission = ControleAcessoWrapper.atualizar(this.editMarcacao);
      editMarcacaoWithPermission(row); // Chama a função após a validação
    }
  }  

  private async saveNewMarcacao(row : any) {

    const params = {
      requestType: 'Row',
      row: {
        ...row,
        NRVINCULOM: this.nrVinculo,
        DIA: this.internalDate,
        HRENTRADA: row.DTHRINICIO,
        HRSAIDA: row.DTHRFIM,
        NRORG: this.user.nrorg,
      },
    };

    const route = 'saveParesMarcacao';

    try {
      this.loadingItems.outro = true;

      const response = await HttpRequest.post(route, params, false);

      const nrMarcacoes = response.data.dataset.data.nrMarcacoes;

      if (!nrMarcacoes) {
        throw new Error('O número da marcação é inválido.')
      }

      if (Array.isArray(nrMarcacoes) && nrMarcacoes.length === 1) {
        SnackbarUtils.showMessage('Apenas uma marcação foi adicionada. Caso não esteja visível, acesse a seção de marcações individuais.', SnackbarUtils.TYPE_ALERT);  
      }

      SnackbarUtils.showMessage('Marcação adicionada com sucesso.');
      this.changed = true;
    } catch(err) {
      this.changed = true;
      let message = 'Não foi possível adicionar a marcação.';

      if (err.isAxiosError) {
        message = err.response.data.error;
        message = message.replace('(HCMSERVICES) ', '');
      }

      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    } finally {
      this.loadingItems.outro = false;
    }

    this.reloadTable();
  }

  private async editMarcacao(row: any) {
    const dates = this.datesArray;

    const rowEdit = {
      dates,
      nrVinculo: this.nrVinculo,
      hrEntrada: row.__backup_row.DTHRINICIO,
      hrSaida: row.__backup_row.DTHRFIM,
      idEntrada: row.__backup_row.DIA_INICIO,
      idSaida: row.__backup_row.DIA_FIM,
      hrNovaEntrada: row.DTHRINICIO,
      hrNovaSaida: row.DTHRFIM,
      novoIdEntrada: row.DIA_INICIO,
      novoIdSaida: row.DIA_FIM,
    }

    this.loadingItems.outro = true;

    try {
      await MarcacaoController.editParesMarcacao(
        rowEdit, false
      );

      this.changed = true;

      const message = 'Marcação editada com sucesso!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_SUCCESS);
    } catch (err) {
      // Tratar resposta com ExpectedError
      // const message = err instanceof ExpectedError ?
      //   err.message :
      //   'Não foi possível editar a marcação';

      let message = 'Não foi possível adicionar a marcação.';

      if (err.isAxiosError) {
        message = err.response.data.error;
        message = message.replace('(HCMSERVICES) ', '');
      }

      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    } finally {
      this.loadingItems.outro = false;
    }

    this.reloadTable();
  }

  private async onDelete(row : any, tableRows : any[]) {
    const dates = this.datesArray;
    const hrEntrada: string = row.DTHRINICIO;
    const hrSaida: string = row.DTHRFIM;
    const idEntrada: string = row.DIA_INICIO;
    const idSaida: string = row.DIA_FIM;

    this.loadingItems.outro = true;

    try {
      await MarcacaoController.removeParesMarcacao(
        this.nrVinculo, dates,
        hrEntrada, hrSaida, false,
        idEntrada, idSaida
      );

      this.changed = true;

      const message = 'Marcação removida com sucesso!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_SUCCESS);
    } catch (err) {
      const e = err as any;
      const message =  e.response.data.error;
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    } finally {
      this.loadingItems.outro = false;
    }

    this.reloadTable();
  }

  private tableAfterReload(rows : any[]) {
    rows.forEach(row => {
      // Tratativa multiplas datas para impossibilitar a edição via click
      if (row.IDMARCACAO === 'Ausência' || !this.canUserEditCurrentPeriodo) {
        row.readonly = true;
      }

      row.DIA_INICIO = this.fixDateId(row.DIA_INICIO);
      row.DIA_FIM = this.fixDateId(row.DIA_FIM);
    });

    const balizaRows = rows.filter((row: any) => {
      const isBaliza =
        row.IDREFERINTERVALO_INI === 'S' &&
        row.IDREFERINTERVALO_FIM === 'S' &&
        row.IDMARCACAO === 'Trabalho' &&
        row.DTHRINICIO === row.DTHRFIM;

      return isBaliza;
    });

    balizaRows.forEach((balizaRow: any) => {
      Util.arrayRemove(rows, balizaRow, false);
    });
  }

  private fixDateId(dateId: string): string {
    if (dateId === 'DA') {
      return 'FA';
    }

    if (dateId === 'DS') {
      return 'FS';
    }

    if (dateId === 'DC' || !dateId) {
      return 'FC';
    }

    return dateId;
  }

  private updateTempoColumn(row : any) {
    if (!row.DTHRFIM) {
      row.TEMPO = '00:00';
      return;
    }

    const inicioTimeString = row.DTHRINICIO;
    const fimTimeString = row.DTHRFIM;

    const inicioDateId = row.DIA_INICIO;
    const fimDateId = row.DIA_FIM;

    const inicio = Time.fromString(inicioTimeString);
    const fim = Time.fromString(fimTimeString);

    const fixedInicio = this.fixTimeWithDateId(inicio, inicioDateId);
    const fixedFim = this.fixTimeWithDateId(fim, fimDateId);

    const tempo = fixedFim.subtract(fixedInicio);
    const tempoString = tempo.toString();

    row.TEMPO = tempoString;
  }

  private fixTimeWithDateId(time: Time, dateId: string): Time {
    const time24Hours = Time.fromString('24:00');
    let fixedTime = time;

    if (dateId === 'FA') {
      fixedTime = time.sum(time24Hours);
    } else if (dateId === 'FS') {
      fixedTime = time.subtract(time24Hours);
    }

    return fixedTime;
  }

  private updateFooterRowValue(rows: any[]): any {
    let timeSum = new Time(0);
    const trabalhoRows = rows.filter(row => row.IDMARCACAO === 'Trabalho');

    trabalhoRows.forEach(row => {
      if (row.TEMPO) {
        const rowTime = Time.fromString(row.TEMPO);
        timeSum = timeSum.sum(rowTime);
      }
    });

    const timeString = timeSum.toString();

    const footer = {
      IDMARCACAO: 'TOTAL',
      TEMPO: timeString,
    };

    return footer;
  }

  private tableOnFieldInput(row : any, column : any, tableRows : any[]) {
    const inicioEFimTemValor =
      !Util.isEmptyOrBlank(row.DTHRINICIO) &&
      !Util.isEmptyOrBlank(row.DTHRFIM);

    if (inicioEFimTemValor) {
      this.updateTempoColumn(row);

      const rows = Util.replaceItem(row, tableRows,
        (item: any) => item.__id === row.__id);
    }
  }

  private async reloadTable() {
    const date = this.datesArray[0];
    let rows: any[] = undefined;
    
    this.rowOnCancel();

    this.loadingItems.reload = true;
    this.rows = [];

    HttpRequest.cancelRequest(this.lastRequest);

    const requestCode = HttpRequest.generateRequestCode();
    this.lastRequest = requestCode;

    await Util.setTimeout(500);

    if (this.lastRequest !== requestCode) {
      return;
    }

    try {
      const request = MarcacaoController.getParesMarcacoesDia(
        this.nrVinculo, date, false, requestCode
      );

      rows = await request;

      if (rows === undefined) {
        return;
      }

      this.rows = rows;
      this.tableAfterReload(this.rows)
    } catch (err) {
      if (this.lastRequest !== requestCode) {
        return;
      }

      const message = 'Não foi possível carregar as marcações!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);
    } finally {
      if (this.lastRequest === requestCode) {
        this.loadingItems.reload = false;
      }
    }
  }

  private tableOnEnter(row, column, tableRows) {
    this.onSave(row, tableRows);
  }

  private isTrabalho(row: any): boolean {
    const trabalho =
      row.IDMARCACAO === 'Trabalho' &&
      row.IDREFERINTERVALO_INI !== 'S' &&
      row.IDREFERINTERVALO_FIM !== 'S';

    return trabalho;
  }

  private isTrabalhoAndAnyFieldEditable(row: any): boolean {
    return this.isTrabalho(row) && (
      this.user.idbloqueioedicaomarc
        ? (row.ID_EDITABLE_PG_INICIO || row.ID_EDITABLE_PG_FIM)
        : true
    );
  }

  private isTrabalhoAndAllFieldsEditable(row: any): boolean {
    return this.isTrabalho(row) && (
      this.user.idbloqueioedicaomarc
        ? row.ID_EDITABLE_PG_INICIO && row.ID_EDITABLE_PG_FIM
        : true
    );
  }

  private isAusencia(row: any): boolean {
    const ausencia = row.IDMARCACAO === 'Ausência';

    return ausencia;
  }

  private isAlmoco(row: any): boolean {
    const almoco = row.NRPROGOCORRENCIA_ALMOCO !== '';

    return almoco;
  }

  private isOcorrencia(row: any): boolean {
    const ocorrencia = row.NRPROGOCORRENCIA_JUSTIFICADA !== '';

    return ocorrencia;
  }

  private sameId(row: any): (item: any) => boolean {
    const comparer = (item: any) => item.__id === row.__id;

    return comparer;
  }

  private canSetAlmoco(row: any): boolean {
    if (!this.vinculo) {
      return false;
    }
    const isCLT = this.vinculo.NRTIPOVINCULOM === '1' || this.vinculo.NRORG != '20';

    const canSet =
      this.isAusencia(row) &&
      !this.hasAlmoco      &&
      !row.NRPROGOCORRENCIA_JUSTIFICADA &&
      isCLT;

    return canSet;
  }

  private async setAlmoco(row: any) {
    const route = this.isPopupSingleMode ? 'insertAlmocoGestor' : 'insertAlmocoMultiplesGestor';

    const params = {
      requestType: 'Row',
      row: {
        NRORG: this.user.nrorg,
        CDOPERADOR: this.user.cdoperador,
        NRVINCULOM: this.nrVinculo,
        DATE: this.internalDate,
        NRMARCACAOPONTO: row.NRMARCACAOPONTO,
      },
    };

    this.loadingItems.outro = true;

    try {
      const response = await HttpRequest.post(route, params, false);

      if (typeof response.data === 'string') {
        throw new Error(response.data);
      }

      const success = response.data.dataset.data.success;

      if (success) {
        const message = 'Almoço definido com sucesso.';
        SnackbarUtils.showMessage(message, 'success', 5000);
      } else {
        const message = 'Já existe uma marcação definida como almoço.';
        SnackbarUtils.showMessage(message, 'alert', 5000);
      }

      this.changed = true;
    } catch(err) {
      const defaultMessage = 'Não foi possível definir o almoço.';
      const errorMessage = err.response.data.error;

      const finalMessage = errorMessage.indexOf('PHP') === -1 ? errorMessage : defaultMessage;
      SnackbarUtils.showMessage(finalMessage, 'error', 5000);

      throw err;
    } finally {
      this.loadingItems.outro = false;
    }

    this.reloadTable();
  }

  private cellOnClick(row: any, column: any) {
    if (this.isIntervalo(row)) {
      this.deleteIntervalo(row);
      return;
    }

    if (this.isAlmoco(row)) {
      this.removeAlmoco(row);
    } else if (this.isOcorrencia(row)) {
      if (row.NRPROGOCORRENCIA_IDPROGOCORCONFIRMADA === 'P') {
        this.removeOcorrencia(row);
      }
    }
  }

  private async removeAlmoco(row: any) {
    const dates = this.datesArray;

    this.loadingItems.outro = true;

    try {
      await OcorrenciaController.removeAlmocos(
        this.nrVinculo, dates, false
      );

      this.changed = true;

      const message = 'Almoço removido com sucesso!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_SUCCESS);
    } catch (err) {
      const message = 'Não foi possível remover o almoço!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    } finally {
      this.loadingItems.outro = false;
    }

    this.reloadTable();
  }

  private iconIsClickable(row: any): boolean {
    return this.canUserEditCurrentPeriodo;
  }

  private hasFile(row: any): boolean {
    const ocorrenciaHasFile = !Util.isEmptyOrBlank(row.NRPROGOCORRENCIA_DSPATH);

    return ocorrenciaHasFile;
  }

  private openOcorDialog(row?: any) {
    this.showOcorDialog = true;

    if (row) {
      this.nrMarcacao = row.NRMARCACAOPONTO;
      this.hrMarcacao = row.DTHRINICIO;
    } else {
      this.nrMarcacao = null;
      this.hrMarcacao = null;
    }
  }

  private canSetOcorrencia(row: any) {
    const hasOcorrencia = row.NRPROGOCORRENCIA_JUSTIFICADA !== '';
    const isAlmoco = this.isAlmoco(row);
    const isAusencia = this.isAusencia(row);

    return !hasOcorrencia && isAusencia && !isAlmoco;
  }

  private ocorDialogAfterSave() {
    this.changed = true;
    this.reloadTable();
  }

  private async removeOcorrencia(row) {
    const dates = this.datesArray;
    const hrMarcacao = row.DTHRINICIO;

    this.loadingItems.outro = true;

    try {
      await OcorrenciaController.removeOcorrenciasFreq(
        this.nrVinculo, dates, hrMarcacao, false
      );

      this.changed = true;

      const message = 'Ocorrência removida com sucesso!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_SUCCESS);
    } catch (err) {
      const message = 'Não foi possível remover a marcação!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    } finally {
      this.loadingItems.outro = false;
    }

    this.reloadTable();
  }

  private getIconColor(row: any): string {
    let color: string;

    if (this.isAlmoco(row)) {
      color = '#195DA9';
    } else if (this.isOcorrencia(row)) {
      const colorRelations = {
        S: 'green',
        P: '#EDC200',
        N: 'red',
      };

      color = colorRelations[row.NRPROGOCORRENCIA_IDPROGOCORCONFIRMADA];
    }

    return color;
  }

  private getIconTooltip(row: any): string {
    let tooltip = '';

    if (this.isAlmoco(row)) {
      tooltip = this.currentMode.almocoOptions.iconLabel;
    } else if (this.isOcorrencia(row)) {
      const motivo = row.NRMOTIVOOCORFREQ_LABEL ? row.NRMOTIVOOCORFREQ_LABEL : 'Ocorrência';

      tooltip = row.NRPROGOCORRENCIA_IDPROGOCORCONFIRMADA === 'P' && this.canUserEditCurrentPeriodo ?
        `Remover "${motivo}"` :
        motivo;
    }

    return tooltip;
  }

  private timesAreValid(
    row: any
  ): boolean {
    if (!row.DTHRFIM) {
      return true;
    }

    const inicio = Time.fromString(row.DTHRINICIO);
    const fim = Time.fromString(row.DTHRFIM);

    const idDiaInicio = row.DIA_INICIO;
    const idDiaFim = row.DIA_FIM;

    const fixedInicio = MarcacaoUtils.fixTimeByDateId(inicio, idDiaInicio);
    const fixedFim = MarcacaoUtils.fixTimeByDateId(fim, idDiaFim);

    const inicioIsGreater = Time.compare(
      fixedInicio.toString(), fixedFim.toString()
    ) === 1;

    return !inicioIsGreater;
  }

  private async downloadFile(
    row: any
  ) {
    const nrMarcacao = row.NRPROGOCORRENCIA_JUSTIFICADA;
    this.loadingItems.outro = true;

    const date = this.datesArray[0];

    try {
      await OcorrenciaController.downloadOcorrenciaFile(
        this.nrVinculo, nrMarcacao, date
      );
    } catch(err) {
      throw err;
    } finally {
      this.loadingItems.outro = false;
    }
  }

  private getIcon(row: any) {
    if (row.ISALMOCO === 'true') {
      return 'mdi-silverware-fork-knife';
    }

    if (row.NRPROGOCORRENCIA_JUSTIFICADA) {
      return 'mdi-android-messages';
    }
  }

  private removeNewRows() {
    // Apenas rows que tem __is_new diferente de true
    const noNewRows = this.rows.filter((row: any) => {
      return !row.__is_new;
    });

    this.rows = noNewRows;
  }

  private async onAdd() {
    this.removeNewRows();
    await this.addRow();

    const secondToLastIndex = this.rows.length - 2;
    this.focusInput(secondToLastIndex);
  }

  private async addRow() {
    await Util.setTimeout(10);

    this.idCurrentRow = 'marcacao';
    this.triggerAddRow++;
  }

  private rowOnEdit(row: any) {
    this.idCurrentRow = 'marcacao';
    this.isInicioReadonlyOnEdit = row && !row.ID_EDITABLE_PG_INICIO;
    this.isFimReadonlyOnEdit = row && !row.ID_EDITABLE_PG_FIM;
    this.forceGridRerender();
  }

  private rowOnCancel() {
    this.isInicioReadonlyOnEdit = false;
    this.isFimReadonlyOnEdit = false;
  }

  private openMarcacoesIndividuaisPopup() {
    this.marcacoesIndividuaisPopup.data.nrVinculo = this.nrVinculo;
    this.marcacoesIndividuaisPopup.control.open(this.internalDate);
  }

  private async addIntervaloAntes() {
    if (!this.verifyInsertIntervalo()) {
      return;
    }

    this.removeNewRows();

    let inicioPrimeiraMarcacao = '';
    let idInicioPrimeiraMarcacao = '';
    const primeiraMarcacao = this.rows[0];

    if (primeiraMarcacao) {
      inicioPrimeiraMarcacao = primeiraMarcacao.DTHRINICIO;
      idInicioPrimeiraMarcacao = primeiraMarcacao.DIA_INICIO;
    }

    this.rows.forEach((row: any) => {
      row.__mode = 'view';
    });

    const ausenciaRow = {
      IDMARCACAO: 'Ausência',
      DTHRINICIO: '',
      DTHRFIM: inicioPrimeiraMarcacao,
      DIA_INICIO: idInicioPrimeiraMarcacao,
      DIA_FIM: idInicioPrimeiraMarcacao,
      __mode: 'edit',
      __is_new: true,
    };

    this.rows.unshift(ausenciaRow);
    this.idCurrentRow = 'before';

    await Util.setTimeout(10);
    this.focusInput(0);
  }

  private async addIntervaloDepois() {
    if (!this.verifyInsertIntervalo()) {
      return;
    }

    this.removeNewRows();

    let fimUltimaMarcacao = '';
    let idFimUltimaMarcacao = '';

    const lastIndex = this.rows.length - 2;
    const ultimaMarcacao = this.rows[lastIndex];

    if (ultimaMarcacao) {
      fimUltimaMarcacao = ultimaMarcacao.DTHRFIM;
      idFimUltimaMarcacao = ultimaMarcacao.DIA_FIM;
    }

    this.rows.forEach((row: any) => {
      row.__mode = 'view';
    });

    const ausenciaRow = {
      IDMARCACAO: 'Ausência',
      DTHRINICIO: fimUltimaMarcacao,
      DTHRFIM: '',
      DIA_INICIO: idFimUltimaMarcacao,
      DIA_FIM: idFimUltimaMarcacao,
      __mode: 'edit',
      __is_new: true,
    };

    const index = this.rows.length - 1;

    this.rows.splice(index, 0, ausenciaRow);
    this.idCurrentRow = 'after';

    await Util.setTimeout(10);
    this.focusInput(index, false);
  }

  private verifyInsertIntervalo(): boolean {
    if (!this.hasMarcacao) {
      const message = 'Não é possível adicionar intervalos em dias sem marcação!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ALERT);

      return false;
    }

    return true;
  }

  private async deleteIntervalo(row: any) {
    const before = row.IDREFERINTERVALO_INI === 'S';

    this.loadingItems.outro = true;

    try {
      const success = await IntervaloController.deleteIntervalo(
        this.nrVinculo, this.datesArray[0], row.DTHRINICIO,
        row.DTHRFIM, before,
      );

      if (success) {
        this.reloadTable();
      }
    } finally {
      this.loadingItems.outro = false;
    }
  }

  private isIntervalo(row: any) {
    const isIntervalo =
      row.IDREFERINTERVALO_INI === 'S' ||
      row.IDREFERINTERVALO_FIM === 'S';

    return isIntervalo;
  }

  private async insertIntervalo(ocorrenciaRow: any) {
    const isValid = this.verifyRequiredFields(ocorrenciaRow);

    if (!isValid) {
      return;
    }

    const date = this.datesArray[0];
    const before = this.idCurrentRow === 'before';

    const time = before ?
      this.currentRow.DTHRINICIO :
      this.currentRow.DTHRFIM;

      this.ocorDialogLoading = true;

      try {
      const success = await IntervaloController.insertIntervalo(
        this.nrVinculo, date, time, before, ocorrenciaRow
      );

      if (success) {
        this.showOcorDialog = false;
        this.reloadTable();
      }
    } finally {
      this.ocorDialogLoading = false;
    }
  }

  private verifyRequiredFields(row: any): boolean {
    const valid = row.__is_valid;

    if (valid) {
      return true;
    }

    const message = 'Favor preencher todos os campos obrigatórios!';
    SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

    return false;
  }

  private onSaveIntervalo() {
    this.openOcorDialog();

    const message = 'É preciso criar uma ocorrência vinculada ao intervalo.';
    SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_INFO2);

    // A função insertIntervalo será executada
    // após o usuário clicar na ação de salvar do dialog de ocorrência
  }

  private focusInput(
    rowIndex: number,
    entrada = true,
  ) {
    const columnName = entrada ?
      'DTHRINICIO' :
      'DTHRFIM';

    const editableTable: Element = (this.$refs.grid as any).$el;
    const tBody = Util.findChildRecursive(editableTable, 'tbody');

    const tableRows = Array.from(tBody.children);

    const trMarcacao = tableRows[rowIndex];
    const columns = trMarcacao.children;

    const indexColumn = this.columns.findIndex((column) =>
      column.value === columnName
    );

    const column = columns[indexColumn];
    const input = Util.findChildRecursive(column, 'input') as HTMLElement;


    input.focus();
  }

  private goToNextDay() {
    this.goToDay(true);
  }

  private goToPreviousDay() {
    this.goToDay(false);
  }

  private goToDay(next: boolean) {
    this.internalDate = next ?
      this.nextDay :
      this.previousDay;

    this.reloadTable();
    this.loadHorarioBase();
  }

  private async loadHorarioBase() {
    if (!this.isPopupSingleMode || Array.isArray(this.internalDate)) {
      return;
    }

    this.nmEscala = '';
    this.loadingItems.horarioBase = true;

    HttpRequest.cancelRequest(this.lastReqHorario);

    const requestCode = HttpRequest.generateRequestCode();
    this.lastReqHorario = requestCode;

    await Util.setTimeout(500);

    if (this.lastReqHorario !== requestCode) {
      return;
    }

    try {
      const request = EscalaController.getDadosHorario(
        this.nrVinculo, this.internalDate, false, requestCode
      );

      const dadosEscala = await request;

      // Atualiza a variável que mostra a escala no titulo
      this.nmEscala = dadosEscala.NMHORDIAH;
    } catch (err) {
      if (this.lastReqHorario !== requestCode) {
        return;
      }

      const message = 'Não foi possível carregar o horário base para o dia em questão!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);
    } finally {
      if (this.lastReqHorario === requestCode) {
        this.loadingItems.horarioBase = false;
      }
    }
  }

  private inicioStyle(row: any): string {
    const idColetorPG = row.ID_COLETOR_PG_INICIO;
    const idColetorAutom = row.ID_COLETOR_AUTOM_INICIO;
    const statusAprovMarc = row.ID_STATUS_MARC_INICIO;
    return this.horarioColumnStyle(statusAprovMarc, idColetorPG, idColetorAutom);
  }

  private fimStyle(row: any): string {
    const idColetorPG = row.ID_COLETOR_PG_FIM;
    const idColetorAutom = row.ID_COLETOR_AUTOM_FIM;
    const statusAprovMarc = row.ID_STATUS_MARC_FIM;
    return this.horarioColumnStyle(statusAprovMarc, idColetorPG, idColetorAutom);
  }

  private horarioColumnStyle(isMarcAprovada: string, idColetorPG: boolean, idColetorAutom: boolean): string {
    switch (isMarcAprovada) {
      case 'P':
        return `color: lightgrey;`;
      case 'N':
        return `color: red;`;
    }

    let color = 'black';
    if (idColetorPG) {
      color = 'blue';
    } else if (idColetorAutom) {
      color = 'darkgoldenrod';
    }
    return `color: ${color};`;
  }

  private forceGridRerender() {
    this.gridKey++;
  }
  // #endregion
}

export default MarcacoesPopup;
